import { createSvgIcon } from '@mui/material';

export const Dot = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <circle cx="14" cy="14.0001" r="14" fill="white" />
    <circle cx="14" cy="14.0001" r="4" fill="currentColor" />
  </svg>,
  'Dot',
);
